import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useProjectActionAssign } from "./project-action-assign.hook";

export const ProjectActionAssign = () => {
  const { runAction } = useProjectActionAssign();

  useEventBusListener(NOTIFICATION_BROADCAST_TYPE.PROJECT_ASSIGN, runAction);

  return <></>;
};
